import axios from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router';

// 请求拦截器 - 添加 token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      if (status === 401) {
        // 未授权，清除 token 并跳转到登录页
        localStorage.removeItem('token');
        localStorage.removeItem('nickname');
        localStorage.removeItem('userId');
        ElMessage.error('登录已过期，请重新登录');
        router.push('/login');
      } else if (status === 403) {
        ElMessage.error('没有权限访问');
      } else if (status === 404) {
        ElMessage.error(data?.message || '请求的资源不存在');
      } else if (status === 500) {
        ElMessage.error(data?.message || '服务器内部错误');
      }
    } else if (error.request) {
      ElMessage.error('网络错误，请检查网络连接');
    }
    
    return Promise.reject(error);
  }
);

export default axios;
